import React from 'react';
import Hero from '../components/Hero';
import TeamSection from '../components/TeamSection';
import heroImage from '../assets/hero/hero-image-aboutus.jpg';

const AboutUs = () => {
  return (
    <>
      <Hero
        title="Welcome to ACM ACC"
        description="Join a vibrant community of tech enthusiasts, innovators, and leaders at Austin Community College. Our ACM Student Chapter bridges the gap between students and the computing industry, offering opportunities in computer science, cybersecurity, AI/ML, big data, hackathons, and design."
        primaryButtonText="Explore Events"
        primaryButtonLink="/events"
        imageSrc={heroImage}
      />
      <TeamSection />
      {/* Rest of the AboutUs content */}
    </>
  );
};

export default AboutUs;
